export default __webpack_public_path__ + "static/media/logos1.f437bcbb.svg";